import { ComponentType, SVGProps } from 'react';
import { McpClaudeColorIcon } from '@/Domain/components/icons/McpClaude.icon';
import { OpenAiIcon } from '@/Domain/components/icons/OpenAi.icon';
import { AccountMcpClient } from '@/Domain/enum/PostHogEvent.enum';

// Quickchat AI's listings in each AI app's directory, shared by the connect sheet and the entry pages.
export const CHATGPT_APP_URL =
  'https://chatgpt.com/plugins/plugin_asdk_app_6a4656c688748191be4c5247fb0d5dfc';
// The /connectors/ form is the URL Anthropic documents as permanent.
export const CLAUDE_DIRECTORY_URL = 'https://claude.ai/directory/connectors/app-quickchat-ai';

export type AiApp = 'chatgpt' | 'claude';

export const AI_APP_LISTINGS = {
  chatgpt: { href: CHATGPT_APP_URL, client: 'chatgpt', Icon: OpenAiIcon },
  claude: { href: CLAUDE_DIRECTORY_URL, client: 'claude_desktop', Icon: McpClaudeColorIcon },
} as const satisfies Record<
  AiApp,
  { href: string; client: AccountMcpClient; Icon: ComponentType<SVGProps<SVGSVGElement>> }
>;
